import { Suspense } from 'react';

import { fetchGetVerifiedBankAccounts } from '@iwoca/lapi-client/edge';
import { Spinner } from '@iwoca/orion';
import { useQuery } from '@tanstack/react-query';

import { AddNewAccount } from './AddNewAccount';
import { PendingAccount } from './PendingAccount';
import { SelectVerifiedAccount } from './SelectVerifiedAccount';
import { VerifiedAccount } from './VerifiedAccount';
import { ErrorBoundary } from '../../../../../errorBoundary/ErrorBoundary';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';
import FallbackErrorModal from '../../../../modals/fallbackErrorModal/FallbackErrorModal';
import { TFundingRequirementsSteps } from '../../orderFundingRequirements';

const BankDetailsAction = ({
    status
}: {
    status: TFundingRequirementsSteps['0']['status'];
}) => {
    const stateKey = useStateKey();
    const { data: verifiedBankAccounts } = useQuery({
        queryKey: ['verified_bank_accounts', stateKey],
        queryFn: () => fetchGetVerifiedBankAccounts({ stateKey: stateKey }),
        suspense: true,
        select: (data) => data.data
    });

    if (status === 'PENDING') {
        return <PendingAccount />;
    }

    if (status === 'COMPLETED') {
        return <VerifiedAccount />;
    }

    if (!verifiedBankAccounts || verifiedBankAccounts.length === 0) {
        return <AddNewAccount />;
    }

    return (
        <SelectVerifiedAccount verifiedBankAccounts={verifiedBankAccounts} />
    );
};

export const BankDetailsActionDE = ({
    status
}: {
    status: TFundingRequirementsSteps['0']['status'];
}) => {
    return (
        <ErrorBoundary fallback={() => <FallbackErrorModal />}>
            <Suspense
                fallback={
                    <Spinner dataTestId="de-bank-details-action-loading" />
                }
            >
                <BankDetailsAction status={status} />
            </Suspense>
        </ErrorBoundary>
    );
};
